import { formatDistanceToNowStrict } from "date-fns";
import enLocale from "date-fns/locale/en-US";

export default function formatDateDistance(date: string, fullFormat?: boolean, hideUnit?: boolean) {
    const formatedDate = formatDistanceToNowStrict(new Date(date), {
        locale: enLocale,
        roundingMethod: "ceil",
    });
    if (fullFormat) {
        return formatedDate;
    }
    const arr = formatedDate.split(" ");
    if (hideUnit) {
        return arr[0];
    }
    return arr[0] + arr[1].slice(0, 1).toLocaleUpperCase();
}
